import { render, staticRenderFns } from "./ChartJS.vue?vue&type=template&id=9a6e9658&scoped=true"
import script from "./ChartJS.vue?vue&type=script&lang=js"
export * from "./ChartJS.vue?vue&type=script&lang=js"
import style0 from "./ChartJS.vue?vue&type=style&index=0&id=9a6e9658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6e9658",
  null
  
)

export default component.exports